var box = {};

( function ( $ ) {

  box.init = function() {
    box.slider();
  };

  var boxSlider = $('.js-box-slider');
  var isFlickity = false;
  var options = {
    cellAlign: 'left',
    contain: true,
    prevNextButtons: false,
    pageDots: true
  }

  box.setSlider = function() {
    if (matchMedia('screen and (max-width: 991px)').matches) {
      boxSlider.flickity(options);
      isFlickity = true;
    } else {
      if (isFlickity) {
        boxSlider.flickity('destroy');
        isFlickity = false;
      }
    }
  };

  box.slider =  function() {
    box.setSlider();

    $(window).resize(function () {
      box.setSlider();
    });
  };

  box.init();

} )( jQuery );